import React from 'react'

const LocateIcon: React.FC = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="tabler:current-location" clip-path="url(#clip0_119_6582)">
                <g id="Group">
                    <path id="Vector" d="M5.99707 8C5.99707 8.53043 6.20778 9.03914 6.58286 9.41421C6.95793 9.78929 7.46664 10 7.99707 10C8.5275 10 9.03621 9.78929 9.41128 9.41421C9.78636 9.03914 9.99707 8.53043 9.99707 8C9.99707 7.46957 9.78636 6.96086 9.41128 6.58579C9.03621 6.21071 8.5275 6 7.99707 6C7.46664 6 6.95793 6.21071 6.58286 6.58579C6.20778 6.96086 5.99707 7.46957 5.99707 8Z" stroke="#007AFF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path id="Vector_2" d="M2.6639 8.00065C2.6639 9.41514 3.2258 10.7717 4.226 11.7719C5.22619 12.7721 6.58274 13.334 7.99723 13.334M2.6639 8.00065C2.6639 6.58616 3.2258 5.22961 4.226 4.22941C5.22619 3.22922 6.58274 2.66732 7.99723 2.66732M2.6639 8.00065H1.33057M7.99723 13.334C9.41172 13.334 10.7683 12.7721 11.7685 11.7719C12.7687 10.7717 13.3306 9.41514 13.3306 8.00065M7.99723 13.334V14.6673M13.3306 8.00065C13.3306 6.58616 12.7687 5.22961 11.7685 4.22941C10.7683 3.22922 9.41172 2.66732 7.99723 2.66732M13.3306 8.00065H14.6639M7.99723 2.66732V1.33398" stroke="#007AFF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_119_6582">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default LocateIcon